/** Whether a file matches an `accept` list of MIME types and extensions. */
export function matchesAccept(file: File, accept: string | undefined): boolean {
  if (!accept) {
    return true;
  }
  const name = file.name.toLowerCase();
  return accept
    .split(',')
    .map((entry) => entry.trim().toLowerCase())
    .some((entry) =>
      entry.startsWith('.')
        ? name.endsWith(entry)
        : entry.endsWith('/*')
          ? file.type.startsWith(entry.slice(0, -1))
          : file.type === entry,
    );
}
